/**
 * Centralized Branding Configuration
 * Change the name and logo path here to update them throughout the application.
 */

export const BRANDING = {
    name: 'A1 Real Estate PVT LTD ',
    logo: (process.env.PUBLIC_URL || '') + '/logoonly.jpeg',
    footerText: '2014-' + new Date().getFullYear() + ' A1. All rights reserved.',
    favicon: (process.env.PUBLIC_URL || '') + '/logoonly.jpeg'
};

export default BRANDING;
